import PropTypes from 'prop-types';
import classOfServicePropType from './classOfService';

export default PropTypes.arrayOf(classOfServicePropType);
